import { jsx as _jsx } from "react/jsx-runtime";
import { Trans } from 'react-i18next';
import { translate } from '../../../strings/i18n';
import { FAS_CIRCLE_EXCLAMATION } from '../../../../../const/icon-props';
import { TextWrapper } from '../subcomponents';
import StatusMessage from '../StatusMessageBox';
import SamsLink from '../../../modal/content/utils/SamsLink';
const NotEligibleMessageBox = () => {
    const samsLinkText = translate('notEligibleMessageBox.subtitle');
    const samsLink = _jsx(SamsLink, { children: samsLinkText });
    return (_jsx(StatusMessage, { iconTitle: "exclamation circle icon", type: "warning", icon: FAS_CIRCLE_EXCLAMATION, messageTitle: translate('notEligibleMessageBox.title'), messageDescription: _jsx(TextWrapper, { children: _jsx(Trans, { i18nKey: "notEligibleMessageBox", value: samsLink, components: { samsLink }, children: translate('notEligibleMessageBox.subtitle', {
                    samsLinkText
                }) }) }) }));
};
export default NotEligibleMessageBox;
